import 'core-js/actual';
import React, { Suspense } from 'react';
import { gsap } from 'gsap';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import ReactDOM from 'react-dom';
import './core/init';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import less from 'less';

import '@pascal/pascal-core/assets/styles/style.css';
import { applicationStore, userInfoStore, userSettingsStore } from '@pascal/pascal-core/shared/core/store';
import { popupStore } from './module/popup';
import { PlatformMessagesWrapper, StoreContext } from '@pascal/pascal-core';
import { PostMessageListenerMessages } from '@pascal/pascal-core/shared/core/services/IframeService';
import { playerService } from './module/player/playerService';

gsap.registerPlugin(CSSRulePlugin);

const App = React.lazy(() => import('./App'));
var isOperaExtreme = (navigator.userAgent.indexOf('Opera Mini/') > -1) && (navigator.userAgent.indexOf('Presto/') > -1);
if (isOperaExtreme) {
  alert('Pls off Extreme Mode');
}
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <PlatformMessagesWrapper additionalMessagesParams={[{name:PostMessageListenerMessages.UpdateBalance , callback:() => playerService.getBalance()}]}>
      <Suspense fallback={null}>
        <StoreContext.Provider value={{
          userSettingsStore,
          applicationStore,
          userInfoStore,
          popUpStore: popupStore,
        }}
        >
          <App />
        </StoreContext.Provider>
      </Suspense>
      </PlatformMessagesWrapper>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
